export enum FilterCategory {
  ROBOTIC_MOWER = 'RoboticMowers',
  MACHINES = 'Machines',
  ATTENTION = 'Attention',
  BATTERY = 'Battery',
  ADD_ASSET = 'AddAsset',
  SEARCH = 'Search',
  NO_FILTER = 'NoFilterSelected',
  FILTERS = 'Filters',
}
